
import Divider from 'vux/src/components/divider/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Card from 'vux/src/components/card/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTable from 'vux/src/components/x-table/index.vue'


export default {
components: {
Divider,
XInput,
Group,
Cell,
Search,
XButton,
Flexbox,
Card,
XTable,
FlexboxItem
},
data () {
return {
currentItem: null,
CODE_TS: '01',
Years: '2019',
expendResult: [],
expendClass: 'fa fa-angle-double-down',
dropdownTitle: '展开目录结构'
}
},
methods: {
async showDesc (index) {
try {
let current = this.expendResult[index]
this.$router.replace({path: 'StatsDirDetail', query: {ID: current.ID}})
} catch (err) {
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
goYearList () {
this.$router.push({name: 'StatsDirYearList', params: this.currentItem})
},
GoTo (CodeTs) {
console.log(CodeTs)
this.$router.push({name: 'GoodsSizeDetails', params: {begin_year: this.Years, end_year: 0, iflag: true, eflag: true, ieflag: true, usd: false, chy: true, keyword: CodeTs}})
},
async expend () {
if (this.expendClass === 'fa fa-angle-double-up') {
this.expendResult = []
this.expendClass = 'fa fa-angle-double-down'
this.dropdownTitle = '展开目录结构'
return
}
try {
let queryPromise = await this.$http.get('/API/StatsDir/SubCodeTS'
, {params: {codeTS: this.currentItem.CODE_TS, year: this.currentItem.Years}})
this.expendResult = queryPromise.data
this.expendClass = 'fa fa-angle-double-up'
this.dropdownTitle = '收起目录结构'
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
},
async loadData () {
try {
this.$vux.loading.show({ text: ' 数据载入中' })
let queryPromise = await this.$http.get('/API/StatsDir/Detail', { params: this.$route.query })
console.log(queryPromise.data)
this.currentItem = queryPromise.data
this.CODE_TS = this.currentItem.CODE_TS
this.Years = this.currentItem.Years
console.log(this.CODE_TS)
this.$vux.loading.hide()
} catch (err) {
this.$vux.loading.hide()
this.$vux.alert.show({
title: '请求失败',
content: err.message })
}
}
},
async created () {
this.Years = ''
await this.loadData()
}
}



// WEBPACK FOOTER //
// ./src/components/StatsDirDetail.vue